import styled from 'styled-components/macro';

import PrimaryButton from 'styled/Buttons/PrimaryButton';

const BigPrimaryButton = styled(PrimaryButton)`
  flex-shrink: 0;
  width: 100%;
  padding: 12px;
  font-size: 14px;
  letter-spacing: 0.7px;
`;

export default BigPrimaryButton;
